import { PaginatedResult } from "@/interfaces/common/PaginatedResult";
import { Product } from "@/interfaces/domain/Product";
import { Promotion } from "@/interfaces/domain/Promotion";
import { api, image_path_promotions, image_path_stores } from "@/services/api";

export async function getPromotionsRequest({
  page = 1,
  limit = 10,
  storeTypeId,
}: {
  page?: number;
  limit?: number;
  storeTypeId?: string;
}) {
  const { data } = await api.get<PaginatedResult<Promotion>>(
    `/v2/promocoes?tipoEstabelecimentoId=${storeTypeId}&page=${page}&limit=${limit}`
  );
  data.docs = data?.docs?.map((item) => ({
    ...item,
    estabelecimento: {
      ...item.estabelecimento,
      foto_estabelecimento: `${image_path_stores}/${item?.estabelecimento?.foto_estabelecimento}`,
    },
    foto_promocao: `${image_path_promotions}/${item.foto_promocao}`,
  }));
  return data;
}

export async function getStorePromotionProductsRequest({
  page = 1,
  limit = 10,
  storeId,
}: {
  storeId: string;
  page?: number;
  limit?: number;
}) {
  const { data } = await api.get<PaginatedResult<Product>>(
    `/v2/promocoes/estabelecimento/${storeId}?page=${page}&limit=${limit}`
  );
  return data;
}
